// ─────────────────────────────────────────────────────────────
// CHAPTER CONFIGURATION — single source of truth
//
// To close a chapter:  set its `state` to 'closed'
// To archive it:       set its `state` to 'archived'
// To open the next:    fill in its fragranceHandles, set state
//                      to 'open', update CURRENT_CHAPTER_ID
//
// Do not hardcode chapter status anywhere else in the codebase.
// ─────────────────────────────────────────────────────────────

export type ChapterState = "prelude" | "open" | "closed" | "archived";

export interface Chapter {
  id: string;
  label: string;
  edition: string;
  state: ChapterState;
  /** Canonical site slugs (Shopify handles resolve via SHOPIFY_HANDLE_ALIASES) */
  fragranceHandles: string[];
  /** Are purchasable Chapter Vials available for this chapter? */
  vialsAvailable: boolean;
  /** Human dispatch window shown on product pages */
  dispatch: string;
}

export const CHAPTERS: Chapter[] = [
  {
    id: "fall-2026",
    label: "Fall 2026",
    edition: "First Edition",
    state: "closed",
    fragranceHandles: [
      "a-gentle-madness",
      "velvet-sugar",
      "the-archivist",
      "hidden",
      "the-still",
    ],
    vialsAvailable: false,
    dispatch: "Third week of September",
  },
  {
    id: "winter-2026",
    label: "Winter 2026",
    edition: "First Edition",
    state: "prelude",
    fragranceHandles: [],
    vialsAvailable: false,
    dispatch: "At the solstice",
  },
];

export const CURRENT_CHAPTER_ID = "fall-2026";
export const NEXT_CHAPTER_ID = "winter-2026";

export const getChapter = (id: string) => CHAPTERS.find((c) => c.id === id);
export const getCurrentChapter = () => getChapter(CURRENT_CHAPTER_ID)!;
export const getNextChapter = () => getChapter(NEXT_CHAPTER_ID)!;

/** Which chapter does a given product slug belong to? */
export const getChapterForHandle = (handle: string) =>
  CHAPTERS.find((c) => c.fragranceHandles.includes(handle));

export const isPurchasable = (state: ChapterState) => state === "open";
